import { render, staticRenderFns } from "./areaStatistic.vue?vue&type=template&id=bf8cc7e2&"
import script from "./areaStatistic.vue?vue&type=script&lang=js&"
export * from "./areaStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports